import React from 'react';

import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';

import classes from 'components/pages/CreateReportPage/CreateReportPage.module.scss';
import { BuildNewReport } from 'components/pages/CreateReportPage/components/BuildNewReport/BuildNewReport';
import { CreateReportPageHeader } from 'components/pages/CreateReportPage/components/CreateReportPageHeader/CreateReportPageHeader';

export const CreateReportPage = () => {
    return (
        <PageContainer>
            <HeaderWrapper className={classes.reportStickyHeader}>
                <BottomHeaderSection>
                    <CreateReportPageHeader />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <BuildNewReport />
            </MainContent>
        </PageContainer>
    );
};
